import { getStoreCombinedSchedule } from "@lib/helpers";

const StoreSchedule = ({ schedule }) => (
  <>
    {getStoreCombinedSchedule(schedule).map((day, index) => (
      <div className="flex" key={index}>
        <span className="mr-1">
          {day.endDay
            ? `${day.startDay} — ${day.endDay}: `
            : `${day.startDay}: `}
        </span>
        {day.openHours}
      </div>
    ))}
  </>
);

export default StoreSchedule;
